module.exports = __webpack_public_path__ + "img/RECEIVE_MONEY.7ec0760d.svg";